 // @ngInject
function setRootScopeVariables($rootScope,$state,AuthService) {
    $rootScope.$state = $state;
    $rootScope.canAccess = AuthService.canAccess;
}

// @ngInject
function initializeAuthService(AuthService) {
    AuthService.setToken();
}

// @ngInject
function eventSubscribers($rootScope,loadSpinnerService, VersionService) {
    // When we go to a new state, pause the state change and check if we are authorized
    $rootScope.$on('$stateChangeStart', function(e, toState, toParams,fromState,fromParams) {
        $rootScope.$applyAsync(loadSpinnerService.start('mainSpinner'));
        $rootScope.toState = toState;
        $rootScope.toParams = toParams;
    });


    $rootScope.$on('$stateChangeSuccess', function(event, toState) {

        //reload client if version has changed
        if (VersionService.hasVersionChanged && VersionService.allowReloadOnStateChange) {
            VersionService.reload();
        } else {
            loadSpinnerService.stop('mainSpinner',{force:true});
        }
        loadSpinnerService.stop('mainSpinner',{force:true});

        if (angular.isDefined(toState.data.pageTitle)) {
            $rootScope.pageTitle = toState.data.pageTitle;
        }
    });

    $rootScope.$on('$stateChangeError', function() {
        loadSpinnerService.stop('mainSpinner',{force:true});
    });
}

angular
    .module('core.init', ['init.angularData'])
    .run(setRootScopeVariables)
    .run(initializeAuthService)
    .run(eventSubscribers);
